import React from 'react'
import ColorImg from '../../../assets/images/information/color.png'

const InfoColors = () => {
  return (
    <div>
        <div className='content-text'>
            Select the <span>Colors for the roof/wall/trim</span> of your building here. Please note that all premium Colors (if offered by the provider) have additional cost added to the building. <br /><br /><span>Wainscot/Two-Tone Color</span> option adds the different color panel 3’ from the bottom to all enclosed walls of the building.
        </div>
        <div className='mt-3'>
            <img src={process.env.REACT_APP_BASE_URL+ColorImg} className='general-img' alt='color'/>
        </div>
    </div>
  )
}

export default InfoColors